import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SearchIcon } from "@heroicons/react/solid";
import { getRegisteredUsers, confirmDeleteRegisteredUser } from '../../services/authService';
import { getCookie } from "../../utils/cookieUtil";
import * as XLSX from "xlsx";
import ExcelFilter from "../../components/ExcelFilter";


function RegisteredUsers({ counter }) {
    const [registeredUsers, setRegisteredUsers] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [permission, setPermission] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);


    const itemsPerPage = 10;
    const navigate = useNavigate();

    useEffect(() => {
        fetchUsers();
    }, []);

    useEffect(() => {
        fetchUsers();
    }, [counter]);

    useEffect(() => {
        const roles = getCookie('roleId');
        if (roles) {
            setPermission(`${roles} `);
        }
    }, []);

    const fetchUsers = async () => {
        setDataLoading(true);
        try {
            const res = await getRegisteredUsers();
            const data = await res.json();
            setRegisteredUsers(data.users);
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setDataLoading(false);
        }
    };

    const handleViewClick = (uid) => {
        navigate(`/app/userdetails?uid=${uid}`);
    };

    const handleDeleteClick = (uid) => {
        setUserToDelete(uid);
        setShowConfirmationModal(true);
    };



    const confirmDelete = async () => {
        try {
            setDataLoading(true);
            await confirmDeleteRegisteredUser(userToDelete);
            setShowConfirmationModal(false);
            setUserToDelete(null);
            setDataLoading(false);
            fetchUsers()
        } catch (error) {
            console.error('[ERROR] Failed to complete deletion process:', error);
        }
    };

    const cancelDelete = () => {
        setShowConfirmationModal(false);
        setUserToDelete(null);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const filteredUsers = Array.isArray(registeredUsers) ? registeredUsers.filter(user =>
        user.email.toLowerCase().includes(searchQuery.toLowerCase())
    ) : [];

    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentUsers = filteredUsers.slice(startIndex, startIndex + itemsPerPage);
    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

    const goToPreviousPage = () => {
        setCurrentPage((prev) => Math.max(prev - 1, 1));
    };

    const goToNextPage = () => {
        setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    };



    if (dataLoading) {
        return (
            <div className="flex-1 flex items-center justify-center">
                <div className="w-16 h-16 border-t-4 border-[#900028] border-solid rounded-full animate-spin"></div>
            </div>
        );
    }


    return (
        <div>
            <div className="flex justify-between items-center mb-4">
                <div className="flex items-center ">
                    <ExcelFilter users={filteredUsers} />
                </div>
                {permission.includes("adduser") && (
                    <div className="ml-auto w-full max-w-md">
                        <div className="flex items-center bg-white shadow-sm border border-gray-200 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-[#900028] transition-all duration-200">
                            <input
                                type="text"
                                placeholder="Search by email..."
                                value={searchQuery}
                                onChange={handleSearchChange}
                                className="flex-1 px-5 py-2.5 text-sm text-gray-800 placeholder-gray-400 bg-transparent focus:outline-none"
                            />
                            <button
                                className="p-3 bg-[#900028] hover:bg-[#a1243b] transition-all duration-200 text-white flex items-center justify-center"
                            >
                                <SearchIcon className="w-5 h-5" />
                            </button>
                        </div>
                    </div>


                )}
            </div>

            <div className="flex-1 overflow-x-auto">
                {/* <div className="overflow-x-auto rounded-xl shadow-sm border border-gray-200 bg-white">
                    <table className="min-w-full text-sm text-left">
                        <thead className="bg-gray-100 text-gray-700 text-sm font-semibold">
                            <tr>
                                {permission.includes("adduser") && (
                                    <>
                                        <th className="px-6 py-3">Email</th>
                                        <th className="px-6 py-3">First Name</th>
                                        <th className="px-6 py-3">Second Name</th>
                                    </>
                                )}
                                <th className="px-6 py-3">Group</th>
                                <th className="px-6 py-3">UID</th>
                                <th className="px-6 py-3 text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-700 divide-y divide-gray-200">
                            {currentUsers.map((user) => (
                                <tr
                                    key={user.uid}
                                    className="hover:bg-gray-50 transition-colors duration-200"
                                >
                                    {permission.includes("adduser") && (
                                        <>
                                            <td className="px-6 py-4">{user.email}</td>
                                            <td className="px-6 py-4">{user.name.firstName}</td>
                                            <td className="px-6 py-4">{user.name.secondName}</td>
                                        </>
                                    )}
                                    <td className="px-6 py-4">{user.group}</td>
                                    <td className="px-6 py-4">{user.uid}</td>
                                    <td className="px-6 py-4 text-center">
                                        <div className="flex justify-center space-x-2">
                                            <button
                                                onClick={() => handleViewClick(user.uid)}
                                                className="bg-[#1E2D40] hover:bg-[#2e435f] text-white text-xs font-medium py-1 px-4 rounded-md"
                                            >
                                                View
                                            </button>
                                            {permission.includes("adduser") && (
                                                <button
                                                    onClick={() => handleDeleteClick(user.uid)}
                                                    className="bg-red-600 hover:bg-red-700 text-white text-xs font-medium py-1 px-4 rounded-md"
                                                >
                                                    Delete
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div> */}

                <div className="overflow-x-auto bg-white shadow-lg rounded-2xl border border-gray-200">
                    <table className="min-w-full text-sm text-left text-gray-700">
                        <thead className="bg-[#900028] text-gray-100 text-xs uppercase tracking-wider">

                            <tr>
                                {permission.includes("adduser") && (
                                    <>
                                        <th className="px-6 py-4">Email</th>
                                        <th className="px-6 py-4">First Name</th>
                                        <th className="px-6 py-4">Second Name</th>
                                    </>
                                )}
                                <th className="px-6 py-4">Group</th>
                                <th className="px-6 py-4">UID</th>
                                <th className="px-6 py-4 text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {currentUsers.map((user) => (
                                <tr
                                    key={user.uid}
                                    className="hover:bg-[#FFF3F7] transition-colors duration-200"
                                >
                                    {permission.includes("adduser") && (
                                        <>
                                            <td className="px-6 py-4 whitespace-nowrap font-medium flex items-center space-x-2">
                                                <div className="bg-[#FFD1E1] text-[#900028] font-bold w-8 h-8 rounded-full flex items-center justify-center text-xs">
                                                    {user.email.charAt(0).toUpperCase()}
                                                </div>
                                                <span>{user.email}</span>
                                            </td>
                                            <td className="px-6 py-4">{user.name.firstName}</td>
                                            <td className="px-6 py-4">{user.name.secondName}</td>
                                        </>
                                    )}
                                    <td className="px-6 py-4">
                                        <span className="inline-block bg-[#FFE1ED] text-[#900028] px-2 py-1 text-xs font-semibold rounded-full">
                                            {user.group}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4">{user.uid}</td>
                                    <td className="px-6 py-4 text-center">
                                        <div className="flex justify-center space-x-2">
                                            <button
                                                onClick={() => handleViewClick(user.uid)}
                                                className="text-indigo-600 border border-indigo-600 hover:bg-indigo-600 hover:text-white transition-all duration-200 text-xs font-semibold py-1 px-4 rounded-md"
                                            >
                                                View
                                            </button>
                                            {permission.includes("adduser") && (
                                                <button
                                                    onClick={() => handleDeleteClick(user.uid)}
                                                    className="text-red-600 border border-red-600 hover:bg-red-600 hover:text-white transition-all duration-200 text-xs font-semibold py-1 px-4 rounded-md"
                                                >
                                                    Delete
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>


                {/* Pagination */}
                <div className="flex justify-end items-center mt-4 mb-2 space-x-2">
                    <button
                        onClick={goToPreviousPage}
                        disabled={currentPage === 1}
                        className="px-3 py-2 bg-gray-300 rounded disabled:opacity-50"
                    >
                        &larr;
                    </button>
                    <span className="px-2">
                        {`1-${Math.min(itemsPerPage, filteredUsers.length - startIndex)} of ${currentPage}`}
                    </span>
                    <button
                        onClick={goToNextPage}
                        disabled={currentPage === totalPages}
                        className="px-3 py-2 bg-gray-300 rounded disabled:opacity-50"
                    >
                        &rarr;
                    </button>
                </div>
            </div>
            {showConfirmationModal && (
  <div className="fixed inset-0 z-50 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center px-4">
    <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 transition-all duration-300 ease-in-out animate-fade-in">
      <h3 className="text-xl font-semibold text-gray-900 mb-3">Confirm Deletion</h3>
      <p className="text-gray-600 mb-6">
        Are you sure you want to permanently delete this user?
      </p>
      <div className="flex justify-end gap-3">
        <button
          onClick={cancelDelete}
          className="px-5 py-2 text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition duration-200"
        >
          Cancel
        </button>
        <button
          onClick={() => confirmDelete(userToDelete)}
          className="px-5 py-2 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 rounded-lg shadow-sm transition duration-200"
        >
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
)}

        </div>
    )
}

export default RegisteredUsers
